var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.toggleFullscreen}},[_c('video',{ref:"videoPlayer",attrs:{"src":_vm.videoUrl,"autoplay":"","loop":"","playsinline":"","controls":"","muted":""},domProps:{"muted":true},on:{"loadedmetadata":_vm.enterFullscreen}})])
}
var staticRenderFns = []

export { render, staticRenderFns }